import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import type { UpgradeTarget } from '@/lib/upgrade-link';

/**
 * Opens the upgrade wizard, on `plan` when given. `hash` is a section of the
 * wizard (its plan comparison).
 */
export function useOpenUpgrade() {
  const navigate = useNavigate();
  return useCallback(
    (options: UpgradeTarget & { hash?: 'compare' } = {}) => {
      void navigate({
        to: '/upgrade',
        search: {
          ...(options.plan ? { plan: options.plan } : {}),
          ...(options.source ? { source: options.source } : {}),
        },
        ...(options.hash ? { hash: options.hash } : {}),
      });
    },
    [navigate]
  );
}
